export default "/fonts/TiemposHeadline-Regular.svg?48416c5293bbcfc6f5a40b979e50583f";